import styled from "styled-components";

export const StyledShowDone = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 16px;
    .layout-ex-img {
        padding: 40px 20px 20px 20px;
        background-color: rgb(255, 255, 255);
        border-radius: 20px;
        text-align: center;
        position: relative;
        span {
            position: absolute;
            top: -32px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            width: 65px;
                height: 65px;
        }
        /* &:after {
            content: "";
            background-image: url(../../images/ic-done-upload.png);
            position: absolute;
            top: -32px;
            left: 50%;
            width: 65px;
            height: 65px;
            display: inline-block;
            position: absolute;
            transform: translateX(-50%);
        } */
        .title {
            font-size: 18px;
            color: ${(props) => props.themeColor};
            font-weight: 600;
            margin-bottom: 5px;
        }
        .detail {
            font-size: 14px;
            color: #9b9b9b;
            margin-bottom: 16px;
        }
    }
    .control-show-img {
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;
